declare global {
  interface Window {
    NREUM?: {
      loader_config?: Record<string, string>
      info?: Record<string, string | number>
    }
  }
}

export default function setupNewRelicAgent() {
  if (!window.NREUM) {
    window.NREUM = {}
  }

  const { NREUM } = window

  if (process.env.NODE_ENV === 'production') {
    NREUM.loader_config = {
      accountID: process.env.NEW_RELIC_ACCOUNT_ID,
      trustKey: process.env.NEW_RELIC_TRUST_KEY,
      agentID: process.env.NEW_RELIC_AGENT_ID,
      licenseKey: process.env.NEW_RELIC_LICENSE_KEY,
      applicationID: process.env.NEW_RELIC_APPLICATION_ID
    }

    NREUM.info = {
      beacon: process.env.NEW_RELIC_BEACON,
      errorBeacon: process.env.NEW_RELIC_ERROR_BEACON,
      licenseKey: process.env.NEW_RELIC_LICENSE_KEY,
      applicationID: process.env.NEW_RELIC_APPLICATION_ID,
      sa: 1
    }
  }
}
